<template>
  <div class="view">
    <router-view />
  </div>
</template>

<style lang="scss">
*,
:after,
:before {
  box-sizing: border-box;
}
body {
  margin: 0;
}
.view {
  position: relative;
  min-height: 100vh;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  display: flex;
}

ol,
ul {
  list-style: none;
}
</style>
